import api from './api';
import {mapSickDayDto} from "../dto/SickDayDTO";

export const getSickEntries = async ({role, userId}) => {
    try {
        const res =
            role === 'admin'
                ? await api.get('/sickday')
                : await api.get(`/sickday/user/${userId}`);
        return res.data.map(mapSickDayDto);
    } catch (err) {
        console.error("Error loading sick day:", err);
        throw err;
    }
};

export const createSickDay = async ({userId, StartDate, EndDate, NumberDays}) => {
    try {
        const res = await api.post('/sickday', {userId, StartDate, EndDate, NumberDays});
        return res.data;
    } catch (err) {
        console.error("Error creating sick day:", err);
        throw err;
    }
}

export const updateSickDay = async (id, {userId, StartDate, EndDate, NumberDays}) => {
    try {
        const res = await api.patch(`/sickday/${id}`, {userId, StartDate, EndDate, NumberDays});
        return res.data;
    } catch (err) {
        console.error("Error updating sick day:", err);
        throw err;
    }
}


export const deleteSickDay = async (id) => {
    try {
        const res = await api.delete(`/sickday/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting sick day:", err);
        throw err;
    }
}
